import React from 'react';
const SvgArchive = React.forwardRef((rest, ref) => {
  const props = { ...rest, ref };
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <path fill="#5C7896" d="M3 1v30h26V8h-7V1H3z" />
      <path opacity={0.3} fill="#1B3F63" d="M29 15l-7-7h7v7z" />
      <path fill="#769CC2" d="M22 1l7 7h-7V1z" />
      <g fill="#FFF">
        <path d="M14 16h4v1h-4v-1zM14 22h4v1h-4v-1zM14 14h4v1h-4v-1zM14 20h4v1h-4v-1zM14 18h4v1h-4v-1zM14 24h4v1h-4v-1zM14 26h4v1h-4v-1zM13 13h4v1h-4v-1zM13 17h4v1h-4v-1zM13 23h4v1h-4v-1zM13 15h4v1h-4v-1zM13 21h4v1h-4v-1zM13 19h4v1h-4v-1zM13 25h4v1h-4v-1zM13 27h4v1h-4v-1zM14 28h4v1h-4v-1zM14 30h4v1h-4v-1zM13 29h4v1h-4v-1z" />
      </g>
      <path opacity={0.8} fill="#1B3F63" d="M15 13h1v18h-1V13z" />
      <path opacity={0.7} fill="#5C7896" d="M13 4h5v11h-5z" />
      <g fill="#FFF">
        <path d="M15 2h1v3h-1V2z" />
        <path d="M14 8h3v3h-3V8zm-1-5v10h5V3h-1v3h-3V3h-1z" />
      </g>
    </svg>
  );
});
export default SvgArchive;
SvgArchive.iconName = 'archive';
SvgArchive.displayName = 'SvgArchive';
